import { render } from "./ServiceStatusDesktop.vue?vue&type=template&id=c078905c&scoped=true"
import script from "./ServiceStatusDesktop.vue?vue&type=script&lang=js"
export * from "./ServiceStatusDesktop.vue?vue&type=script&lang=js"

import "./ServiceStatusDesktop.vue?vue&type=style&index=0&id=c078905c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c078905c"]])

export default __exports__